import { render, staticRenderFns } from "./TimeclockOrderTabEmployeesAddDialog.vue?vue&type=template&id=729e3478&"
import script from "./TimeclockOrderTabEmployeesAddDialog.vue?vue&type=script&lang=ts&"
export * from "./TimeclockOrderTabEmployeesAddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports